import * as React from 'react';
import { Button, Col, ControlLabel, Form, FormGroup } from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import { flow, map } from 'lodash';
import { connect } from 'react-redux';
import { isRequired } from '../../../../../util/validators';
import { IAuthState } from '../../../../../services/auth/models';
import { CUSTOMER_PASSWORD_UPDATE_SUCCESS, IAuthActions } from '../../../../../services/auth/reducer';
import { IStore } from '../../../../../redux/IStore';
import { FaCog } from 'react-icons/fa';
import PropTypes from 'prop-types';
import PasswordInput from '../../../../../components/PasswordInput';

const FORM_NAME = 'manage_account';

interface IUpdatePasswordFormProps {
  actions: {
    push: (route: string) => void;
    auth: IAuthActions;
  };
  buttonText: string;
  auth: IAuthState;
  dispatch: PropTypes.func.isRequired;
  handleSubmit: PropTypes.func.isRequired;
  submitting: boolean;
}

class UpdatePasswordForm extends React.Component<IUpdatePasswordFormProps> {
  public componentWillUnmount(): void {
    const { dispatch } = this.props;

    dispatch({ type: CUSTOMER_PASSWORD_UPDATE_SUCCESS, value: false });
  }

  public render() {
    const { buttonText, auth, handleSubmit, submitting } = this.props;
    const hasAuthErrors = auth && auth.updateCustomerPassword.failed
      && auth.error && auth.error.updateCustomerPassword && auth.error.updateCustomerPassword.length;

    return (
      <Form horizontal={true} onSubmit={handleSubmit} autoComplete="off">
        <div>
          <div>
            <FormGroup controlId="password">
              <Col componentClass={ControlLabel} sm={4}>
                Password
              </Col>
              <Col sm={8}>
                <Field
                  name="currentPassword"
                  type="password"
                  autoComplete="new-password"
                  component={PasswordInput}
                  validate={[isRequired]}
                />
              </Col>
            </FormGroup>
            <FormGroup controlId="password">
              <Col componentClass={ControlLabel} sm={4}>
                New Password
              </Col>
              <Col sm={8}>
                <Field
                  name="newPassword"
                  type="password"
                  autoComplete="new-password"
                  component={PasswordInput}
                  strengthMeter={true}
                  validate={[isRequired]}
                />
              </Col>
            </FormGroup>
            <FormGroup controlId="name">
              <Col componentClass={ControlLabel} sm={4}>
                Confirm new password
              </Col>
              <Col sm={8}>
                <Field
                  name="newPasswordConfirmation"
                  type="password"
                  autoComplete="new-password"
                  component={PasswordInput}
                  validate={[isRequired]}
                />
              </Col>
            </FormGroup>
            <div className="margin-bottom">
              Your password must be a minimum of 10 characters long with at least one lower case, one uppercase letter,
              one number and one of the following special characters : !@#$%?
            </div>
          </div>
        </div>
        {hasAuthErrors && (
          <div className="alert alert-danger" style={{ marginTop: '10px' }}>
            {map(auth.error.updateCustomerPassword, (error, key) => {
              if (error.detail === 'Password is unacceptable') {
                return <p>Unfortunately the password you have chosen contains a word that is in our banned list of
                  passwords. Please choose a password that is more secure.</p>;
              } else {
                return <p key={key}>{error.detail.replace('12', '10')}</p>;
              }
            })}
          </div>
        )}
        {auth.updateCustomerPassword.success && (
          <div className="alert alert-success" style={{ marginTop: '10px' }}>
            Your password has been updated successfully
          </div>
        )}
        <div className="btn-bar mt-30">
          <Button
            bsStyle="primary"
            type="submit"
            bsSize="small"
            className="pull-right medium-width secondary-button"
            disabled={submitting}
          >

            {submitting ? <FaCog className="fa-spin"/> : (buttonText ? buttonText : 'SAVE CHANGES')}
          </Button>
        </div>
      </Form>
    );
  }
}

const validate = (values) => {
  const errors = {};
  if (values.newPasswordConfirmation !== values.newPassword) {
    errors.newPasswordConfirmation = 'Your confirmed password doesn\'t match the first field, please enter them again.';
  }
  return errors;
};

export default flow([
  reduxForm({
    form: FORM_NAME,
    validate
  }),
  connect((state: IStore) => {
      return {
        auth: state.auth,
      };
    },
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
      },
    }),
  ),
])(UpdatePasswordForm);
